import { parsePhoneNumberFromString } from 'libphonenumber-js'

export function stringHashCode(string: string): number {
  let hash = 0,
    i,
    chr
  if (string.length === 0) return hash
  for (i = 0; i < string.length; i++) {
    chr = string.charCodeAt(i)
    hash = (hash << 5) - hash + chr
    hash |= 0 // Convert to 32bit integer
  }
  return Math.abs(hash)
}

export function formatNumber(phoneNumber: string): string {
  if (!phoneNumber) return phoneNumber
  const parsedNumber = parsePhoneNumberFromString(phoneNumber, 'ES')
  return String(parsedNumber ? parsedNumber.number : phoneNumber)
}

export function fuzzy(text: string, search: string): boolean {
  const [lText, lSearch] = [text, search].map(str => str.toLowerCase())
  let j = 0
  for (let i = 0; i < lText.length; i++) {
    if (lText[i] === lSearch[j]) j++
  }
  return j === search.length
}

export function isNullOrEmpty(stringInput: string | null | undefined): boolean {
  return stringInput == null || stringInput.trim() === ''
}

export function toKebabCase(text: string): string {
  return text
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
}

export function capitalize(text: string): string {
  if (isNullOrEmpty(text)) return text
  return text.toLowerCase().replace(/([A-Za-zÀ-ÖØ-öø-ÿ])/, m => m.toUpperCase())
}

export function toHash(string: string) {
  let hash = 0
  if (string.length == 0) return hash
  for (let i = 0; i < string.length; i++) {
    const char = string.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }
  return hash
}

export function uppercaseFirst(text: string): string {
  if (isNullOrEmpty(text)) return text
  return text.replace(/([A-Za-zÀ-ÖØ-öø-ÿ])/, m => m.toUpperCase())
}

export function generateSlug(text: string): string {
  return text.replace('|', '').replace(/\s+/g, '-').toLowerCase()
}
